import { $4 } from 'global';

class TymAtcStop extends HTMLElement {
  connectedCallback() {
    this.footer = $4(this.getAttribute('watch'));
    if (!this.footer) return;

    const lead = parseInt(this.getAttribute('lead'), 10) || 0;

    this.observer = new IntersectionObserver(
      ([entry]) => document.body.classList.toggle('tym-atc-parked', entry.isIntersecting),
      { rootMargin: `0px 0px ${lead}px 0px` }
    );

    this.observer.observe(this.footer);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    document.body.classList.remove('tym-atc-parked');
  }
}

if (!customElements.get('tym-atc-stop')) {
  customElements.define('tym-atc-stop', TymAtcStop);
}
